import { createAsyncTypes } from 'utils/ActionCreator'

export const STATUS_REQUEST_ASYNC = createAsyncTypes(
  'STATUS_REQUEST_ASYNC',
  'Settings/EmailServer/Gsuite'
)
export const ENABLE_INTEGRATION_REQUEST_ASYNC = createAsyncTypes(
  'ENABLE_INTEGRATION_REQUEST_ASYNC',
  'Settings/EmailServer/Gsuite'
)
export const DISABLE_INTEGRATION_REQUEST_ASYNC = createAsyncTypes(
  'DISABLE_INTEGRATION_REQUEST_ASYNC',
  'Settings/EmailServer/Gsuite'
)
export const DELETE_CREDENTIALS_REQUEST_ASYNC = createAsyncTypes(
  'DELETE_CREDENTIALS_REQUEST_ASYNC',
  'Settings/EmailServer/Gsuite'
)

export const SET_LOADER = 'Settings/EmailServer/Gsuite/SetLoader'

export const STATUS_LIST_OPTIONS = {
  NO_CREDS: 0,
  HAS_CREDS_DISABLED: 1,
  ENABLED: 2,
}
